import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'modal-update-dependent-insurance',
	templateUrl: './modal-update-dependent-insurance.component.html',
	imports: [
		CommonModule,  MatSelectModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemNotificationComponent, FormsModule
	]
})
export class ModalUpdateDependentInsuranceComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalUpdateDependentInsuranceComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.getEmployeeName = this.getEmployeeName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'tw-' + Date.now();
		this.vm.businessUserDependent = this.vm.businessUserDependent;
		this.vm.user = this.session.getSession().user;
		this.vm.isInsuranceDatePickerHidden = this.session.isInsuranceDatePickerHidden();
		this.vm.extraData = {};
		this.vm.extraData.dependentInvitation = {};
		this.vm.extraData.dependentInvitation.id = this.vm.businessUserDependent.id;
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			var minDate: any = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.getExistingInsurancePolicies = this.getExistingInsurancePolicies;
		this.vm.activePolicies = this.filterOutActivePolicies(
			this.vm.businessUserDependent.employeeInsuranceWallets, 
			this.vm.businessUserDependent.insuranceWallets
		);
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	filterOutActivePolicies(employeeActiveInsuranceWallets, dependentInsuranceWallets) {
		var result: Array<any> = [];
		if (employeeActiveInsuranceWallets && employeeActiveInsuranceWallets.length > 0) {
			MAIN: for (var i = 0; i < employeeActiveInsuranceWallets.length; i++) {
				if (dependentInsuranceWallets && dependentInsuranceWallets.length > 0) {
					for (var j = 0; j < dependentInsuranceWallets.length; j++) {
						if (employeeActiveInsuranceWallets[i].policy.id == dependentInsuranceWallets[j].policy.id) {
							continue MAIN;
						}
					}
				}
				result.push(employeeActiveInsuranceWallets[i].policy);
			}
		}
		
		return result;
	}
	
	getName() {
		return this.vm.businessUserDependent ? this.vm.businessUserDependent.firstName + ' ' + this.vm.businessUserDependent.lastName : '';
	}
	
	getEmployeeName() {
		return this.vm.businessUserDependent && this.vm.businessUserDependent.worker ?
		this.vm.businessUserDependent.worker.employee.firstname + ' ' + this.vm.businessUserDependent.worker.employee.lastname : '';
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized || !this.vm.selectedPolicy) return;
		this.vm.processing = true;
		
		var extraData: any = {};
		extraData.dependentInvitation = this.vm.extraData.dependentInvitation;
		extraData.policy = this.vm.selectedPolicy;
		extraData.activationDate = this.vm.extraData.activationDate
			? moment(this.vm.extraData.activationDate).utcOffset(0, true).toDate()
			: new Date();
		extraData.terminationDate = this.vm.extraData.terminationDate
			? moment(this.vm.extraData.terminationDate).utcOffset(0, true).toDate()
			: undefined;
		
		this.restService.saveBusinessClientUserUpdateDependentInvitationExtra(extraData)
			.then((response) => {
				this.vm.businessUserDependent.processing = false;
				this.dialogRef.close(response);
				var parentEl: any = document.getElementById('dependent-action-element-' + this.vm.businessUserDependent.id);
				this.toast.showWithTranslationInParent('Toast.Worker.InsuranceUpdateSent', parentEl);
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
				var parentEl: any = document.getElementById('modal-' + this.vm.uid);
				this.toast.showWithTranslationInParent('Toast.Worker.InsuranceUpdateFailed', parentEl);
			});
	}
	
	getExistingInsurancePolicies() {
		var policies: any = "";
		for (var i = 0; i < this.vm.businessUserDependent.insuranceWallets.length; i++) {
			var wallet: any = this.vm.businessUserDependent.insuranceWallets[i];
			policies += ((policies.length > 0 ? ", " : "") + wallet.policy.policyNumber);
		}
		
		return this.angularFilterHelperService.translate('Employees.Placeholder.ExistingInsurancePolicies')
		+ ": "
		+ policies;
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}